export const getCourseIdFromUrl = (): string | null => {
  const path = window.location.pathname;
  if (!path.includes('curso')) return null;
  const start = path.indexOf('/curso/') + 7;
  const end = path.includes('aula') ? path.indexOf('/aula/') : path.length;
  return path.substring(start, end);
};
